// extracted by css-extract-rspack-plugin
var _1 = "addedValue-ulJ2jA";
var _2 = "content-Bl_kJA";
var _3 = "diff-hJJkAK";
var _4 = "emptyValue-qM6bg3";
var _5 = "fullValue-ls8Ngq";
var _6 = "header-PbLJKE";
var _7 = "removedValue-PiR7D9";
var _8 = "singleValue-in5xa_";
var _9 = "value-g_Sifi";
var _a = "valueTitle-q7SjSr";
var _b = "values-p3qAjP";
export { _1 as "addedValue", _2 as "content", _3 as "diff", _4 as "emptyValue", _5 as "fullValue", _6 as "header", _7 as "removedValue", _8 as "singleValue", _9 as "value", _a as "valueTitle", _b as "values" }
